import { get } from 'lodash';
import { createSelector } from 'reselect';
import { RootStateType } from '../rootReducer';
import i18n, { TFunctionResult } from 'i18next';

const ITEMS_NOT_LOGGED_IN = [
  { id: 'authorization', name: i18n.t('profile.login.title') },
  {
    id: 'parental-control',
    name: i18n.t('profile.pin.title'),
    metadata: i18n.t('profile.pin.disabled'),
  },
];

const ITEMS_LOGGED_IN = [
  { id: 'authorization', name: i18n.t('profile.account') },
  { id: 'parental-control', name: i18n.t('profile.parentalLock') },
];

const getProfileSelector = (state: RootStateType) => state.profile;

export const selectProfileData = createSelector(getProfileSelector, (profile) => profile.data);

export const selectIsLoggedIn = createSelector(getProfileSelector, (profile) => profile.isLoggedIn);

export const selectProfileError = createSelector(getProfileSelector, (profile) => profile.error);

export const selectPin = createSelector(selectProfileData, (data) => data.pc_pin);

export const selectParentalControlData = createSelector(
  getProfileSelector,
  (profile) => profile.parentalControl || null,
);

export const selectIsParentalConterolEnabled = createSelector(selectParentalControlData, (data) =>
  get(data, ['pc_level'], 0),
);

export const selectParentalAge = createSelector(
  selectParentalControlData,
  (data) => (data || {}).pc_level || 0,
);

const PARENTAL_ITEMS = [
  { name: 'Age', id: 'age', path: 'age' },
  /* { name: 'Pin Protection', id: 'pin-protection' },*/
  { name: 'Change Pin', id: 'pin-create-new' },
];

export const selectParentalControlItems = createSelector(selectParentalControlData, (data) => {
  return PARENTAL_ITEMS.map((item) => {
    let metadata: string | number | TFunctionResult = '';

    if (item.id === 'age') metadata = data.pc_level > 0 ? `${data.pc_level}+` : 'No limits';
    if (item.id === 'pin-protection')
      metadata = data.pc_level > 0 ? i18n.t('profile.pin.enabled') : i18n.t('profile.pin.disabled');

    return { ...item, metadata };
  });
});

export const selectProfileItems = createSelector(
  selectIsLoggedIn,
  selectProfileData,
  selectParentalControlData,
  (isLoggedIn, profileData, parentalControl) => {
    if (isLoggedIn) {
      return ITEMS_LOGGED_IN.map((item) => {
        const { id } = item;
        if (id === 'authorization' && profileData) {
          return { ...item, metadata: profileData.username };
        }
        if (id === 'parental-control' && parentalControl) {
          return {
            ...item,
            metadata:
              parentalControl.pc_level > 0
                ? i18n.t('profile.pin.enabled')
                : i18n.t('profile.pin.disabled'),
          };
        }
        return item;
      });
    }
    return ITEMS_NOT_LOGGED_IN;
  },
);
